import { useMutation } from "src/Hooks/useReactQuery";
import { saveTestSequenceTags } from "src/services/test-packages";

const useUpdateTestSequenceTags = (options = {}) => {
  const { showAlert, t, toggle, onSuccess, onError, onSettled, ...restOptions } = options;

  return useMutation({
    mutationFn: ({ testPackageId, tags }) => saveTestSequenceTags(testPackageId, tags),
    onSuccess: (data, variables) => {
      if (showAlert && t) {
        showAlert({
          status: true,
          message: t("list.tag_modal.tags_saved_successfully"),
          type: "success",
        });
      }

      if (toggle) {
        toggle();
      }

      if (onSuccess) {
        onSuccess(data, variables);
      }
    },
    onError: (error, variables) => {
      if (showAlert && t) {
        showAlert({
          status: true,
          message: t("list.tag_modal.error_saving_tags"),
          type: "danger",
        });
      }

      if (onError) {
        onError(error, variables);
      }
    },
    onSettled: (data, error, variables) => {
      if (onSettled) {
        onSettled(data, error, variables);
      }
    },
    ...restOptions,
  });
};

export default useUpdateTestSequenceTags;
